<template>
  <div
    ref="wrap"
    class="vue-slide-bar-component vue-slide-bar-horizontal"
    :style="calculateMinHeight"
    @click="wrapClick">
    <div ref="elem" class="vue-slide-bar">
      <template>
        <div ref="dot"
          class="vue-slide-bar-always vue-slide-bar-dot"
          @mousedown="moveStart"
          @touchstart="moveStart">
          <span class="vue-slide-bar-tooltip-top vue-slide-bar-tooltip-wrap" v-if="showTooltip">
            <slot name="tooltip">
              <span class="vue-slide-bar-tooltip">
                <span class="vue-slide-bar-tooltip-stick"
                  :style="{'left': `${tooltip_stick_left}px`}"
                ></span>
                {{ val }}
              </span>
            </slot>
          </span>
        </div>
      </template>
      <div ref="process" class="vue-slide-bar-process"></div>
    </div>
    <div v-if="range" class="vue-slide-bar-range">
      <div v-for="(r, index) in range" :key="index" class="vue-slide-bar-separate">
        <span v-if="!r.isHide" class="vue-slide-bar-separate-text">
          {{ r.label }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
const Tortoise = require('@/assets/js/cb').Tortoise
const sprintf = require('@/assets/js/sprintf.min').sprintf
require('@/assets/js/cb.date')

export default {
  name: 'TimeSlideBar',
  data () {
    return {
      data: [],
      range: [],
      min: 0,
      max: 0,
      flag: false,
      size: 0,
      currentValue: 0,
      currentSlider: 0,
      isComponentExists: true,
      interval: 1,
      realTime: true,

      selected_time: null,
      tooltip_stick_shift: 25,
      default_tooltip_stick_left: 19,
      tooltip_stick_left: 0,
      ending_count: 0,
      recycling: 2
    }
  },
  props: {
    speed: {
      type: Number,
      default: 0
    },

    inittime: { // as init time
      type: [String, Number],
      default: 0
    },

    showTooltip: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    labelStyles: Object
  },
  computed: {
    slider () {
      return this.$refs.dot
    },
    val: {
      get () {
        if (this.data) {
          let dt = new Date(this.data[this.currentValue]);
          if (!isNaN(dt)) {
            return dt.strftime("%H:%M");
          }
        }
        return this.currentValue;
      },
      set (val) {
        if (this.data) {
          let index = this.data.indexOf(val)
          if (index > -1) {
            this.currentValue = index
          }
        } else {
          this.currentValue = val
        }
      }
    },
    currentIndex () {
      return (this.currentValue - this.minimum) / this.spacing
    },
    indexRange () {
      return [0, this.currentIndex]
    },
    minimum () {
      return this.min
    },
    maximum () {
      return this.max
    },
    multiple () {
      let decimals = `${this.interval}`.split('.')[1]
      return decimals ? Math.pow(10, decimals.length) : 1
    },
    spacing () {
      return this.data ? 1 : this.interval
    },
    total () {
      if (this.data) {
        return this.data.length - 1
      } else if (Math.floor((this.maximum - this.minimum) * this.multiple) % (this.interval * this.multiple) !== 0) {
        this.printError('[VueSlider error]: Prop[interval] is illegal, Please make sure that the interval can be divisible')
      }
      return (this.maximum - this.minimum) / this.interval
    },
    gap () {
      return this.size / this.total
    },
    position () {
      return ((this.currentValue - this.minimum) / this.spacing * this.gap)
    },
    limit () {
      return [0, this.size]
    },
    valueLimit () {
      return [this.minimum, this.maximum]
    },
    calculateMinHeight () {
      return this.range ? { minHeight: '28px' } : {}
    }
  },

  watch: {

    value (val) {
      if (this.flag) this.setValue(val, true)
      else this.setValue(val, true, this.speed)
    },

    inittime (val, old) {
      if (val !== old) {
        this.ending_count = 0;
        if (typeof(val)=='string' && val.length == 12) {
          this.refresh(true);
        }
      }
    }

  },

  methods: {
    bindEvents () {
      document.addEventListener('touchmove', this.moving, {passive: false})
      document.addEventListener('touchend', this.moveEnd, {passive: false})
      document.addEventListener('mousemove', this.moving)
      document.addEventListener('mouseup', this.moveEnd)
      document.addEventListener('mouseleave', this.moveEnd)
      window.addEventListener('resize', this.refresh)
    },
    unbindEvents () {
      window.removeEventListener('resize', this.refresh)
      document.removeEventListener('touchmove', this.moving)
      document.removeEventListener('touchend', this.moveEnd)
      document.removeEventListener('mousemove', this.moving)
      document.removeEventListener('mouseup', this.moveEnd)
      document.removeEventListener('mouseleave', this.moveEnd)
    },
    getPos (e) {
      this.realTime && this.getStaticData()
      return e.clientX - this.offset
    },
    wrapClick (e) {
      if (this.isDisabled) return false
      let pos = this.getPos(e)
      this.setValueOnPos(pos)
    },
    moveStart (e, index) {
      this.flag = true
      this.$emit('drag-start', this)
    },
    moving (e) {
      if (!this.flag) return false
      e.preventDefault()
      if (e.targetTouches && e.targetTouches[0]) e = e.targetTouches[0]
      this.setValueOnPos(this.getPos(e), true)
    },
    moveEnd (e) {
      if (this.flag) {
        this.$emit('drag-end', this)
        if (this.isDiff(this.val, this.value)) {
          this.syncValue()
        }
      } else {
        return false
      }
      this.flag = false
      this.setPosition()
    },
    setValueOnPos (pos, isDrag) {
      let range = this.limit
      let valueRange = this.valueLimit
      if (pos >= range[0] && pos <= range[1]) {
        this.setTransform(pos)
        let v = (Math.round(pos / this.gap) * (this.spacing * this.multiple) + (this.minimum * this.multiple)) / this.multiple
        this.setCurrentValue(v, isDrag)
      } else if (pos < range[0]) {
        this.setTransform(range[0])
        this.setCurrentValue(valueRange[0])
        if (this.currentSlider === 1) this.currentSlider = 0
      } else {
        this.setTransform(range[1])
        this.setCurrentValue(valueRange[1])
        if (this.currentSlider === 0) this.currentSlider = 1
      }
    },
    isDiff (a, b) {
      if (Object.prototype.toString.call(a) !== Object.prototype.toString.call(b)) {
        return true
      } else if (Array.isArray(a) && a.length === b.length) {
        return a.some((v, i) => v !== b[i])
      }
      return a !== b
    },
    setCurrentValue (val, bool) {
      if (val < this.minimum || val > this.maximum) return false
      if (this.isDiff(this.currentValue, val)) {
        this.currentValue = val
        this.syncValue(undefined, bool)
      }
      bool || this.setPosition()
    },
    setIndex (val) {
      val = this.spacing * val + this.minimum
      this.setCurrentValue(val)
    },
    setValue (val, noCb, speed) {
      if (this.isDiff(this.val, val)) {
        let resetVal = this.limitValue(val)
        this.val = resetVal
        this.syncValue(noCb)
      }
      this.$nextTick(() => this.setPosition(speed))
    },
    setPosition (speed) {
      if (!this.flag) this.setTransitionTime(speed === undefined ? this.speed : speed)
      else this.setTransitionTime(0)
      this.setTransform(this.position)
    },
    setTransform (val) {
      let value = val - this.tooltip_stick_shift;
      if (value < 0) {
        this.tooltip_stick_left = this.default_tooltip_stick_left + value;
        value = 0;
      }
      else {
        this.tooltip_stick_left = this.default_tooltip_stick_left;
      }
      let translateValue = `translateX(${value}px)`
      this.slider.style.transform = translateValue
      this.slider.style.WebkitTransform = translateValue
      this.slider.style.msTransform = translateValue
      this.$refs.process.style.width = `${val}px`
      this.$refs.process.style['left'] = 0
    },
    setTransitionTime (time) {
      this.slider.style.transitionDuration = `${time}s`
      this.slider.style.WebkitTransitionDuration = `${time}s`
      this.$refs.process.style.transitionDuration = `${time}s`
      this.$refs.process.style.WebkitTransitionDuration = `${time}s`
    },
    limitValue (val) {
      if (this.data) {
        return val
      }
      const inRange = (v) => {
        if (v < this.min) {
          this.printError(`[VueSlider warn]: The value of the slider is ${val}, the minimum value is ${this.min}, the value of this slider can not be less than the minimum value`)
          return this.min
        } else if (v > this.max) {
          this.printError(`[VueSlider warn]: The value of the slider is ${val}, the maximum value is ${this.max}, the value of this slider can not be greater than the maximum value`)
          return this.max
        }
        return v
      }
      return inRange(val)
    },

    valueInRange(val) {
      if (this.data && this.data.length > 0) {
        if (val < this.data[0]) { return false; }
        if (val > this.data[this.data.length-1]) { return false; }
      }
      else {
        // if (val >= this.min && val <= this.max) {
        //   return true;
        // }
      }
      return true;
    },

    syncValue (noCb, is_moving) {
      let val = this.val
      if (this.data) {
        let val = this.data[this.currentIndex];
        val = new Date(val);
        if (!isNaN(val)) {
          val = val.toUTC();
          this.selected_time = val.dtgftime();
          this.$emit('time_slider_callback', val.valueOf(), is_moving)
        }
      }
      this.$emit('input', val)
      noCb || this.$emit('callback', val)
    },
    getValue () {
      return this.val
    },
    getIndex () {
      return this.currentIndex
    },
    getStaticData () {
      if (this.$refs.elem) {
        this.size = this.$refs.elem.offsetWidth
        this.offset = this.$refs.elem.getBoundingClientRect().left
      }
    },

    set_selected_time(val) {
      if (val && val !== this.selected_time) {
        this.ending_count = 0;
        if (typeof(val)=='string' && val.length == 12) {
          let _dt = Date.dtgptime(val);
          if (!isNaN(_dt)) {
            this.selected_time = val;
            _dt = _dt.setTimezone(0).toLocal();
            let new_val = _dt.valueOf();
            let old_val = this.data[this.currentIndex];
            if (new_val !== old_val) {
              if (this.valueInRange(new_val)) {
                if (this.flag) this.setValue(new_val, true);
                else this.setValue(new_val, true, this.speed);
              }
              else {
                // pass
              }
            }

            return true;
          }
        }
        console.error("not valid dtg");
      }
    },

    range_datetime () {
      var self = this;

      self.data = [];
      self.range = [];

      let dt_format = "%m/%d 星期%-a";
      let range_days = 7;
      let elem_w = document.querySelector('.vue-slide-bar').clientWidth;
      if (elem_w < 400) {
        range_days = 5;
        dt_format = "%d";
      }
      else if (elem_w < 592) {
        range_days = 5;
        dt_format = "%d(%-a)";
      }
      else if (elem_w < 768) {
        range_days = 7;
        dt_format = "%d(%-a)";
      }

      let min_h = 0;
      let max_h = 24 * range_days;
      self.min = min_h;
      self.max = max_h;

      try {
        var _init = Date.dtgptime(self.inittime);
        _init = _init.setTimezone(0).toLocal();
      }
      catch(e) {
        return;
      }

      if (!isNaN(_init)) {
        _init.setHours(0, 0, 0, 0);

        for (let h=min_h; h<=max_h; h++) {
          let v = _init.addHours(h);
          self.data.push(v.valueOf());

          if (h > min_h && h < max_h) {
            switch (v.getHours()) {
              case 0:
                self.range.push({
                  label: "|"
                });
                break;
              case 12:
                self.range.push({
                  label: v.strftime(dt_format)
                });
                break;
              default:
                self.range.push({
                  label: ""
                });
            }
          }
          else {
            self.range.push({
              label: ""
            });
          }
        }

        if (self.data && self.data.length) {
          if (self.selected_time) {
            let _dt = Date.dtgptime(self.selected_time);
            if (!isNaN(_dt)) {
                _dt = _dt.setTimezone(0).toLocal();
                let new_val = _dt.valueOf();
                if (this.valueInRange(new_val)) {
                  this.setValue(new_val);
                }
            }
            else {
              // pass
            }}
        }
      }
    },

    refresh (reset) {
      var self = this;

      if (!self.tortoise) {
        var _refresh = function(reset) {
          if (reset) {
            self.range_datetime();
          }

          if (self.$refs.elem) {
            self.getStaticData()
            self.setPosition()
          }
        };

        self.tortoise = new Tortoise(_refresh, {
            delay: 200
        });
      }
      self.tortoise.punch(reset);
    },

    next() {
      return this.step(1);
    },

    prev() {
      return this.step(-1);
    },

    step(val) {
      /*
        argv: step to go, 1 to next, -1 to prev
        return: 1 success, 0 fail, -1 to the end
      */
      let new_idx = this.currentIndex + val;
      if (new_idx < 0 || new_idx >= this.data.length) {
        if (this.recycling > 0) {
          this.ending_count ++;
          if (this.ending_count > this.recycling) {
            this.ending_count = 0;
            if (new_idx < 0) new_idx = this.data.length - 1;
            else new_idx = 0;
          }
        }
        else {
          return -1;
        }
      }
      this.setIndex(new_idx);
      return 1;
    },

    printError (msg) {
      console.error(msg)
    }
  },
  mounted () {
    this.isComponentExists = true
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return this.printError('[VueSlider error]: window or document is undefined, can not be initialization.')
    }
    this.$nextTick(() => {
      if (this.isComponentExists) {
        this.getStaticData()
        this.setValue(this.limitValue(this.value), true, 0)
        this.bindEvents()
      }
    })
  },
  beforeDestroy () {
    this.isComponentExists = false
    this.unbindEvents()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/TimeSlideBar.vue